import { render, staticRenderFns } from "./DefStandardList.vue?vue&type=template&id=5ccfbb58&scoped=true&"
import script from "./DefStandardList.vue?vue&type=script&lang=js&"
export * from "./DefStandardList.vue?vue&type=script&lang=js&"
import style0 from "./DefStandardList.vue?vue&type=style&index=0&id=5ccfbb58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccfbb58",
  null
  
)

export default component.exports